import React from 'react';
import { pdf } from '@react-pdf/renderer';
import { AvisoCobroPDF } from '../components/pdf/AvisoCobroPDF';

/**
 * Generates and downloads PDF for an Aviso de Cobro
 * @param {Object} aviso - The aviso data object
 * @param {boolean} isPrueba - Whether this is a test aviso
 * @returns {Promise<{success: boolean, error?: Error}>}
 */
export const generateAndDownloadPDF = async (aviso, isPrueba = false) => {
  try {
    console.log('[PDF] Starting PDF generation for aviso:', aviso?.numeroAviso);
    console.log('[PDF] Aviso data:', aviso);

    const blob = await pdf(<AvisoCobroPDF aviso={aviso} isPrueba={isPrueba} />).toBlob();
    console.log('[PDF] Blob generated successfully, size:', blob.size, 'bytes');

    const filename = `aviso_cobro_${aviso.numeroAviso}${isPrueba ? '_PRUEBA' : ''}.pdf`;
    console.log('[PDF] Filename:', filename);

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    console.log('[PDF] Download triggered');
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 100);

    return { success: true };
  } catch (error) {
    console.error('[PDF] Error generating PDF:', error);
    console.error('[PDF] Error stack:', error.stack);
    return { success: false, error };
  }
};

/**
 * Opens PDF in new tab instead of downloading
 * @param {Object} aviso - The aviso data object
 * @param {boolean} isPrueba - Whether this is a test aviso
 * @returns {Promise<{success: boolean, error?: Error}>}
 */
export const openPDFInNewTab = async (aviso, isPrueba = false) => {
  try {
    console.log('[PDF] Opening PDF in new tab for aviso:', aviso?.numeroAviso);
    const blob = await pdf(<AvisoCobroPDF aviso={aviso} isPrueba={isPrueba} />).toBlob();
    console.log('[PDF] Blob generated, opening in new tab...');
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 100);
    return { success: true };
  } catch (error) {
    console.error('[PDF] Error opening PDF:', error);
    console.error('[PDF] Error stack:', error.stack);
    return { success: false, error };
  }
};

/**
 * Generates PDF blob for email attachment (does not download)
 * @param {Object} aviso - The aviso data object
 * @param {boolean} isPrueba - Whether this is a test aviso
 * @returns {Promise<{success: boolean, blob?: Blob, filename?: string, error?: Error}>}
 */
export const generatePDFBlob = async (aviso, isPrueba = false) => {
  try {
    console.log('[PDF] Generating PDF blob for aviso:', aviso?.numeroAviso);
    const blob = await pdf(<AvisoCobroPDF aviso={aviso} isPrueba={isPrueba} />).toBlob();
    console.log('[PDF] Blob generated for email attachment, size:', blob.size, 'bytes');
    const filename = `aviso_cobro_${aviso.numeroAviso}${isPrueba ? '_PRUEBA' : ''}.pdf`;
    return { success: true, blob, filename };
  } catch (error) {
    console.error('[PDF] Error generating PDF blob:', error);
    console.error('[PDF] Error stack:', error.stack);
    return { success: false, error };
  }
};
